module.exports = __webpack_public_path__ + "static/media/logoRms.b4d8facf.svg";